import axios from 'axios';
import { rootAPI } from '../../config/api';
import { bearerToken } from '../../config/auth';

// Action types
export const FETCH_CREDENTIALS_DATA_REQUEST = 'FETCH_CREDENTIALS_DATA_REQUEST';
export const FETCH_CREDENTIALS_DATA_SUCCESS = 'FETCH_CREDENTIALS_DATA_SUCCESS';
export const FETCH_CREDENTIALS_DATA_FAILURE = 'FETCH_CREDENTIALS_DATA_FAILURE';

export const FETCH_CHANNEL_CREDENTIALS_DATA_REQUEST = 'FETCH_CHANNEL_CREDENTIALS_DATA_REQUEST';
export const FETCH_CHANNEL_CREDENTIALS_DATA_SUCCESS = 'FETCH_CHANNEL_CREDENTIALS_DATA_SUCCESS';
export const FETCH_CHANNEL_CREDENTIALS_DATA_FAILURE = 'FETCH_CHANNEL_CREDENTIALS_DATA_FAILURE'; 

// Action creators for V1
export const fetchCredentialsRequest = () => ({ type: FETCH_CREDENTIALS_DATA_REQUEST });
export const fetchCredentialsSuccess = (data) => ({ type: FETCH_CREDENTIALS_DATA_SUCCESS, payload: data });
export const fetchCredentialsFailure = (error) => ({ type: FETCH_CREDENTIALS_DATA_FAILURE, payload: error });

// Action creators for V2
export const fetchChannelCredentialsRequest = () => ({ type: FETCH_CHANNEL_CREDENTIALS_DATA_REQUEST });
export const fetchChannelCredentialsSuccess = (data) => ({
  type: FETCH_CHANNEL_CREDENTIALS_DATA_SUCCESS,
  payload: data,
});
export const fetchChannelCredentialsFailure = (error) => ({
  type: FETCH_CHANNEL_CREDENTIALS_DATA_FAILURE,
  payload: error,
});

// Thunk - Old V1
export const fetchCredentials = (appId) => {
  return async (dispatch) => {
    dispatch(fetchCredentialsRequest());
    try {
      const response = await axios.get(`${rootAPI}/api/third-party/connect/${appId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearerToken}`,
        },
      });
      dispatch(fetchCredentialsSuccess(response.data || []));
    } catch (error) {
      dispatch(fetchCredentialsFailure(error.message));
    }
  };
};

// Thunk - New V2
export const fetchChannelCredentials = (appId) => {
  return async (dispatch) => {
    dispatch(fetchChannelCredentialsRequest());
    try {
      const response = await axios.get(`${rootAPI}/api/basic/v2.0.0/credentials/${appId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearerToken}`,
        },
      });

      const credentialsData = response.data?.data || null;

      dispatch(fetchChannelCredentialsSuccess(credentialsData));
    } catch (error) {
      dispatch(fetchChannelCredentialsFailure(error.message));
    }
  };
};
